export const SCORE_ICS = (scanWaveId?: string) =>
  `/api/v1/score/innovation-culture-score${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const SCORE_INNOVATION_PERCEPTIONS = (scanWaveId?: string) =>
  `/api/v1/score/innovation-perceptions${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const SCORE_IDENTITY = (scanWaveId?: string) =>
  `/api/v1/score/identity${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const SCORE_DEPTH_ELEMENTS = (type: string, scanWaveId?: string) =>
  `/api/v1/score/depth-elements/${type}${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const SCORE_DEPTH_BEHAVIOURS = (elementName: string, scanWaveId?: string) =>
  `/api/v1/score/depth-behaviours/${elementName}${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
export const SCORE_IDENTITY_PERCEPTIONS_JOURNEY = '/api/v1/score/identity-journey/';
export const SCORE_IDENTITY_PERCEPTIONS_MINDSET = '/api/v1/score/identity-mindset';
export const SCORE_DEPTH_IDENTITY = '/api/v1/score/depth-identity/';
export const SCORE_ELEMENT_THEMES = '/api/v1/score/element-themes';
